import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SET_RESTAURANT_DETAILS,
  GET_FILTER_TABLE_DATA,
} from "../types";
import Alert from "react-s-alert";
import { setErrors } from "../actions/errorActions";
import { serverApi } from "../../config/Keys";

export const add_map_details = (formData, history) => async (dispatch) => {
  //console.log(formData);
  dispatch({ type: SET_LOADER });
  try {
    let map_details = await axios.post(`${serverApi}/restaurant`, formData);
    if (map_details.data) {
      //   dispatch({
      //     type: SET_RESTAURANT_DETAILS,
      //     payload: map_details.data.restaurant,
      //   });
      dispatch({ type: CLEAR_LOADER });
      history.push("/restaurantsettings");
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - REORDER MENU ITEM VENDOR
 *****************************************/
export const reorder_menu_category_item =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let reorder_menu_category_item = await axios.post(
        `${serverApi}/menuCategory/order`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (reorder_menu_category_item.status === 201) {
        onSuccess(reorder_menu_category_item);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - REORDER MENU ITEM VENDOR
 *****************************************/
export const filterQrTableData =
  (formData, vendorId, token, limit, pageno, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    try {
      let filterQrTableData = await axios.post(
        `${serverApi}/subscription/table?vendor_id=${vendorId}&limit=${limit}&page=${pageno}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (filterQrTableData.status === 201) {
        onSuccess(filterQrTableData);
        dispatch({
          type: GET_FILTER_TABLE_DATA,
          payload: filterQrTableData?.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
